import {
  Box,
  Column,
  Columns,
  Hidden,
  IconInfo,
  Stack,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import { vars } from 'braid-design-system/css';

import type { JobAdFeatureChartSiteConfig } from './chartData';
import { TableCellBox, TableRow } from './components/TableUI';

const Pink = ({ children }: { children: React.ReactNode }) => (
  <span style={{ color: vars.foregroundColor.brandAccent }}>{children}</span>
);

export const JobAdPlanHeader = ({
  embed,
  data,
}: {
  embed?: boolean;
  data: JobAdFeatureChartSiteConfig;
}) => (
  <TableRow colNum={data.colNum} embed={embed}>
    <TableCellBox embed={embed}>
      <Box />
    </TableCellBox>
    {data.headerPlan.map((item) => (
      <TableCellBox key={item.label} alignY="top" embed={embed}>
        <Stack space={{ mobile: 'xsmall', desktop: 'medium' }}>
          <TableHeaderLabel label={item.label} icon={item.icon} />
          <TableHeaderDescription textSpan={item.textSpan} text={item.text} />
        </Stack>
      </TableCellBox>
    ))}
  </TableRow>
);

export const TableHeaderLabel = ({
  label,
  icon,
}: {
  label: string;
  icon: React.ReactNode;
}) => (
  <Columns
    space="xxsmall"
    align="center"
    alignY="center"
    collapseBelow="desktop"
    reverse
  >
    <Column width="content">{icon}</Column>
    <Column width="content">
      <Hidden below="desktop">
        <Text size="large" weight="medium">
          <Pink>{label}</Pink>
        </Text>
      </Hidden>
      <Hidden above="tablet">
        <Text weight="medium">
          <Pink>{label}</Pink>
        </Text>
      </Hidden>
    </Column>
  </Columns>
);

export const TableHeaderDescription = ({
  textSpan,
  text,
}: {
  textSpan: React.ReactNode;
  text: string;
}) => (
  <>
    <Hidden below="desktop">{textSpan}</Hidden>
    <Hidden above="tablet">
      <Box width="full" justifyContent="center" display="flex">
        <TooltipRenderer
          id="info-premium"
          tooltip={<Text size="xsmall">{text}</Text>}
        >
          {({ triggerProps }) => (
            <Box aria-label="Info" {...triggerProps}>
              <IconInfo tone="info" />
            </Box>
          )}
        </TooltipRenderer>
      </Box>
    </Hidden>
  </>
);
